import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Tooltip, Card, Spin } from "antd";
import { Helmet } from "react-helmet";
import { LoadingOutlined } from "@ant-design/icons";

import { getChunkByKey } from "../services/utils";
import { renderAsDiv } from "../pages/chunk-page";
import logo from "../assets/logo.png"; // Usamos el logo principal

/**
 * Pagina de redireccionamiento a otra pagina
 * @returns
 */
function RedirectPage() {
  const [text, setText] = useState("");
  const [url, setUrl] = useState("");
  const [seconds, setSeconds] = useState(3);
  const [isValidUrl, setIsValidUrl] = useState(true);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchDataChunk = async (chunk) => {
      try {
        const res = await getChunkByKey(chunk);
        if (res && res.content) {
          setText(res.content);
        }
      } catch (error) {
        console.log("Error fetching chunk");
      }
    };

    fetchDataChunk("redirect");
  }, []);

  useEffect(() => {
    const targetUrl = searchParams.get("url");
    if (targetUrl) {
      if (targetUrl.startsWith("http://") || targetUrl.startsWith("https://")) {
        setUrl(targetUrl);
        setIsValidUrl(true);
      } else {
        setIsValidUrl(false);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    if (url && isValidUrl) {
      const intervalId = setInterval(() => {
        setSeconds((prev) => {
          if (prev <= 1) {
            clearInterval(intervalId);
            window.location.href = url;
            return 0; // Se detiene exactamente en 0
          }
          return prev - 1;
        });
      }, 1000);

      // Limpieza: detiene el intervalo al desmontar
      return () => clearInterval(intervalId);
    }
  }, [url, isValidUrl]);

  return (
    <>
      <Helmet>
        <title>Redirigiendo... | littlecoders.dev. Aprende Python mientras organizas tu día</title>
      </Helmet>

      <div 
        style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          minHeight: "100vh", 
          backgroundColor: "#f8f9fa", 
          padding: "20px" 
        }}
      >
        <div style={{ maxWidth: "500px", width: "100%" }}>
          <Card
            cover={
              <div className="text-center" style={{ padding: "40px 20px 20px" }}>
                <img src={logo} alt="littlecoders.dev" style={{ width: "220px", maxWidth: "100%" }} />
              </div>
            }
            className="text-center"
            style={{ 
              borderRadius: "15px", 
              boxShadow: "0 10px 30px rgba(0,0,0,0.05)", 
              border: "none" 
            }}
          >
            {url && isValidUrl ? (
              <>
                <h3 style={{ color: "#333", fontWeight: "bold", fontSize: "1.5rem", marginBottom: "15px" }}>
                  Te estamos redirigiendo...
                </h3>
                <p style={{ fontSize: "1.1rem", color: "#666", marginBottom: "25px" }}>
                  Serás redirigido/a en <strong>{seconds}</strong> segundos.
                </p>

                <div style={{ margin: "20px 0" }}>
                  <Spin indicator={<LoadingOutlined style={{ fontSize: 36, color: "#FA824C" }} spin />} />
                </div>

                <div className="mt-4 pt-3">
                  <Tooltip title={`Ir inmediatamente a ${url}`}>
                    <a
                      href={url}
                      rel="noreferrer"
                      style={{
                        display: "inline-block",
                        backgroundColor: "#5B88FA",
                        color: "white",
                        padding: "10px 25px",
                        borderRadius: "25px",
                        fontWeight: "bold",
                        textDecoration: "none",
                        transition: "background-color 0.2s"
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = "#3b68da"}
                      onMouseOut={(e) => e.target.style.backgroundColor = "#5B88FA"}
                    >
                      Continuar a la página
                    </a>
                  </Tooltip>
                </div>
              </>
            ) : url && !isValidUrl ? (
                <div style={{ padding: "20px" }}>
                  <h3 style={{ color: "#fa5b5b" }}>URL no válida</h3>
                  <p style={{ color: "#666" }}>El enlace de destino parece ser inseguro o incorrecto.</p>
                </div>
            ) : (
                <div style={{ padding: "20px" }}>
                  <h3 style={{ color: "#333" }}>Ningún destino configurado</h3>
                  <a href="/" style={{ color: "#5B88FA", fontWeight: "bold", textDecoration: "none" }}>Volver a la portada</a>
                </div>
            )}

            {text && (
              <div style={{ marginTop: "30px", paddingTop: "20px", borderTop: "1px solid #eee", color: "#666", fontSize: "0.95rem" }}>
                {renderAsDiv(text)}
              </div>
            )}
          </Card>
        </div>
      </div>
    </>
  );
}

export default RedirectPage;
